// Write a class to handle the custom audio player
const CLOCK = 60;
const TIME_TO_UPDATE = 200;
export default class CustomAudioPlayer {
  constructor(audio, settings = {}) {
    this.audio = audio;
    this.settings = {
      prefix: settings.prefix || 'custom-audio-player',
      playButtonMarkup: settings.playButtonMarkup || 'Lancer la lecture',
      pauseButtonMarkup: settings.pauseButtonMarkup || 'Arrêter la lecture',
      ...settings
    };
    this.init();
  }

  init() {
    this.buildPlayer();
    this.attachEvents();
  }

  /**
   * Build the custom audio player markup.
   *
   * @returns {void}
   */
  buildPlayer() {
    const player = document.createElement('div');
    player.classList.add(this.settings.prefix + '__player');
    player.innerHTML = `
      <div class="${this.settings.prefix}__row">
        <div class="${this.settings.prefix}__timeline" data-audio-player="timeline">
          <div class="${this.settings.prefix}__progress">
            <button type="button" data-audio-player="current-position"><span>Position</span></button>
          </div>
        </div>
        <div class="${this.settings.prefix}__controls">
          <span class="${this.settings.prefix}__timecode" data-audio-player="timecode">00:00</span>
          <button type="button" data-audio-player="play" title="Lancer la lecture">${this.settings.playButtonMarkup}</button>
          <button type="button" data-audio-player="pause" title="Arrêter la lecture">${this.settings.pauseButtonMarkup}</button>
        </div>
      </div>
    `;

    this.customPlayer = player;
    this.playControl = player.querySelector('[data-audio-player="play"]');
    this.pauseControl = player.querySelector('[data-audio-player="pause"]');
    this.timelineControl = player.querySelector('[data-audio-player="timeline"]');
    this.progressBar = player.querySelector(`.${this.settings.prefix}__progress`);
    this.handleControl = player.querySelector('[data-audio-player="current-position"]');
    this.timecode = player.querySelector('[data-audio-player="timecode"]');

    this.setState('paused');

    this.audio.after(player);
  }

  attachEvents() {
    this.customPlayer.querySelector('[data-audio-player="play"]').addEventListener('click', this.onPlay.bind(this));
    this.customPlayer.querySelector('[data-audio-player="pause"]').addEventListener('click', this.onPause.bind(this));

    this.audio.addEventListener('timeupdate', this.updateProgress.bind(this));
    this.audio.addEventListener('timeupdate', this.updateTimeCode.bind(this));

    // Detect when the audio has ended.
    this.audio.addEventListener('ended', () => {
      this.setProgress(0);
      this.setState('paused');
    });

    this.timelineControl.addEventListener('click', (event) => {
      const timelineWidth = this.timelineControl.offsetWidth;
      const clickPosition = event.offsetX;
      const newPosition = clickPosition / timelineWidth * this.audio.duration;

      this.audio.currentTime = newPosition;
    });

    this.audio.addEventListener('timeupdate', () => {
      this.updateTimecode(this.audio.currentTime);
    });

    this.handleControl.addEventListener('click', (event) => {
      event.stopPropagation();
    });

    // Left and right arrow keys to move the current position.
    this.handleControl.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        this.audio.currentTime -= 5;
      } else if (event.key === 'ArrowRight') {
        this.audio.currentTime += 5;
      }
    });

    this.handleControl.addEventListener('mousedown', (event) => {
      this.audio.pause();
      this.setState('paused');

      const handleMouseMove = (event) => {
        const timelineWidth = this.timelineControl.offsetWidth;
        const clickPosition = event.clientX - this.timelineControl.getBoundingClientRect().left;
        const newPosition = clickPosition / timelineWidth * this.audio.duration;

        // Update progress bar.
        this.audio.currentTime = Math.min(this.audio.duration, Math.max(0, newPosition));
      };

      const handleMouseUp = () => {
        this.audio.play();
        this.setState('playing');

        window.removeEventListener('mousemove', handleMouseMove);
        window.removeEventListener('mouseup', handleMouseUp);
      };

      window.addEventListener('mousemove', handleMouseMove);
      window.addEventListener('mouseup', handleMouseUp);
    });

    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(() => {
        const minutes = Math.floor(this.audio.duration / CLOCK);
        const seconds = Math.floor(this.audio.duration % CLOCK);
        const initialDuration = `${minutes}:${seconds.toString().padStart(2, '0')}`;
        this.timecode.textContent = initialDuration;
      }, TIME_TO_UPDATE);
    });
  }

  onPlay() {
    this.audio.play();
    this.setState('playing');
    this.pauseControl.focus();
  }

  onPause() {
    this.audio.pause();
    this.setState('paused');
    this.playControl.focus();
  }

  setProgress(value) {
    this.progressBar.style.width = `${value}%`;
  }

  updateProgress() {
    const progress = this.audio.currentTime / this.audio.duration * 100;
    this.setProgress(progress);
  }

  updateTimeCode() {
    const minutes = Math.floor(this.audio.currentTime / CLOCK);
    const seconds = Math.floor(this.audio.currentTime % CLOCK);
    const padded = `${minutes}:${seconds.toString().padStart(2, '0')}`;
    this.timecode.textContent = padded;
  }


  setState(state) {
    this.customPlayer.setAttribute('data-audio-player-state', state);

    if (state === 'playing') {
      // Hide play button.
      this.playControl.classList.add(this.settings.prefix + '__hidden');
      this.pauseControl.classList.remove(this.settings.prefix + '__hidden');
    } else {
      // Hide pause button.
      this.pauseControl.classList.add(this.settings.prefix + '__hidden');
      this.playControl.classList.remove(this.settings.prefix + '__hidden');
    }
  }
}
